import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";

const SideBar = ({ items }) => {
  const sidebarlink = {
    width: "100%",
    position: "relative",
    display: "flex",
    color: "#181818",
    // padding: "8px 0px 8px 13px",
    textDecoration: "none",
    listStyle: "none",
    justifyContent: "space-between",
    height: "50px",
    alignItems: "center",
    padding: "0 13px",
    borderRadius: "4px",
  };

  const blueSideBar = {
    width: "100%",
    textDecoration: "none",
    position: "relative",
    backgroundColor: "#2563EB",
    color: "#fff ",
    display: "flex",
    justifyContent: "space-between",
    //padding: "8px 0px 8px 13px",
    listStyle: "none",
    height: "50px",
    alignItems: "center",
    padding: "0 13px",
    borderRadius: "4px",
  };

  const [subnav, setSubnav] = useState(false);
  const location = useLocation();
  const [item, setItem] = useState({});

  const showSubnav = () => {
    setSubnav(!subnav);
  };

  useEffect(() => {
    if (location.pathname === items.path)
      setItem({
        ...items,
        selected: true,
      });
    else
      setItem({
        ...items,
        selected: false,
      });

    if (items.subNav && items.subNav.length) {
      items.subNav.forEach((i) => {
        if (i.path === location.pathname) i["selected"] = true;
        else i["selected"] = false;
      });
    }
  }, [items, location.pathname]);

  return (
    <>
      <div
        onMouseEnter={() => {
          if (item.subNav) showSubnav();
        }}
        onMouseLeave={() => {
          if (item.subNav) showSubnav();
        }}
      >
        <div>
          <Link
            className=" hover:bg-[#DEE7FC]"
            style={item.selected ? blueSideBar : sidebarlink}
            to={item.path}
          >
            <div
              style={{
                display: "flex",
                minWidth: "230px",
                alignItems: "center",
              }}
            >
              {item.icon}
              <p className="ml-5 text-sm ">{item.title}</p>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default SideBar;
